import NewsletterCTA from "../components/NewsletterCTA";

export default function CaliforniaPrivacy() {
  return (
    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">
        California Privacy Notice
      </h1>
      <p className="mt-2 text-sm text-slate-600">
        Effective Date: April 30, 2025
      </p>

      <p className="mt-6 text-slate-700">
        This Supplemental Privacy Notice for California Residents is intended
        solely for visitors, users, and individuals residing in the State of
        California (“consumers” or “you”). This notice supplements our main
        Privacy Policy and is provided in accordance with the California
        Consumer Privacy Act (CCPA) and other applicable California privacy
        laws.
      </p>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">
        Categories of Personal Information Collected
      </h2>
      <ul className="mt-2 list-disc pl-6 text-slate-700 space-y-1">
        <li>Identifiers (e.g., name, address, IP address)</li>
        <li>
          Information that identifies, relates to, or could reasonably be linked
          with you
        </li>
        <li>
          Internet or electronic network activity (e.g., browsing history,
          device data)
        </li>
        <li>Geolocation data</li>
      </ul>
      <p className="mt-2 text-slate-700">
        We collect data directly from you, from your browser, and via
        third-party technologies such as cookies and pixels.
      </p>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">
        Business and Commercial Purposes
      </h2>
      <ul className="mt-2 list-disc pl-6 text-slate-700 space-y-1">
        <li>Providing, maintaining, and improving the website</li>
        <li>Matching you with law firms or legal service providers</li>
        <li>Marketing and advertising (including affiliate programs)</li>
        <li>
          Analytics and user behavior tracking (e.g., session replay, heatmaps)
        </li>
        <li>
          Fraud/security detection, legal compliance, customer support,
          debugging, research
        </li>
      </ul>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">
        Use of Tracking Technologies &amp; CIPA Disclosure
      </h2>
      <p className="mt-2 text-slate-700">
        We use cookies, session replay tools, and similar technologies to
        monitor interactions (e.g., mouse movements, scrolling, clicks) for
        analytics and optimization. <strong>CIPA Notice:</strong> By using this
        site, you consent to such monitoring. Data is used for business purposes
        and is not shared or sold without your consent.
      </p>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">
        Your CCPA Rights
      </h2>
      <ul className="mt-2 list-disc pl-6 text-slate-700 space-y-1">
        <li>Right to know (categories/specific pieces collected)</li>
        <li>Right to delete</li>
        <li>Right to opt-out of sale or sharing</li>
        <li>Right to correct inaccurate information</li>
        <li>Right not to be discriminated against</li>
      </ul>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">
        How to Exercise Your Rights
      </h2>
      <p className="mt-2 text-slate-700">
        Email:{" "}
        <a className="underline" href="mailto:info@masstortplaintiffs">
          info@masstortplaintiffs.com
        </a>
        <br />
        Mail: PO Box 214, Oceanside, NY 11572
      </p>
      <p className="mt-2 text-slate-700">
        You may authorize an agent to act on your behalf by providing written
        permission. We may verify your identity and the agent’s authority before
        processing requests.
      </p>

      <h2 className="mt-8 text-xl font-bold text-[#0A2540]">Accessibility</h2>
      <p className="mt-2 text-slate-700">
        If you have a disability that prevents access to this notice, contact{" "}
        <a className="underline" href="mailto:info@masstortplaintiffs.com">
          info@masstortplaintiffs.com
        </a>{" "}
        for an alternative format.
      </p>

      <NewsletterCTA />
    </main>
  );
}
